import { render } from "./PromiseView.vue?vue&type=template&id=77f3147d&scoped=true"
const script = {}

import "./PromiseView.vue?vue&type=style&index=0&id=77f3147d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f3147d"]])

export default __exports__